<template>
  <div>
    <div class="header-wrapper">
      <div class="header">
        <div class="logo-wrapper">
          <div class="logo wow fadeIn" @click="goToHome">
            <img src="../assets/images/logo-main.svg" alt="Logo">
          </div>
        </div>
        <div class="menu-wrapper">
          <div class="demo-3">
            <main class="main main--demo-3">
              <div class="content content--demo-3">
                <div class="hamburger hamburger--demo-3 js-hover">
                  <div class="hamburger__line hamburger__line--01">
                    <div class="hamburger__line-in hamburger__line-in--01"></div>
                  </div>
                  <div class="hamburger__line hamburger__line--02">
                    <div class="hamburger__line-in hamburger__line-in--02"></div>
                  </div>
                  <div class="hamburger__line hamburger__line--03">
                    <div class="hamburger__line-in hamburger__line-in--03"></div>
                  </div>
                  <div class="hamburger__line hamburger__line--cross01">
                    <div class="hamburger__line-in hamburger__line-in--cross01"></div>
                  </div>
                  <div class="hamburger__line hamburger__line--cross02">
                    <div class="hamburger__line-in hamburger__line-in--cross02"></div>
                  </div>
                </div>
                <div class="global-menu">
                  <div class="global-menu__wrap">
                    <div class="global-menu__item global-menu__item--demo-3 menu-logo">
                      <!--<img class="pop-logo" src="../assets/images/logo-popup.svg">-->
                      <img class="pop-logo" src="../assets/images/logo-main.svg">
                    </div>
                    <div class="container global-menu__item global-menu__item--demo-3 about-desc">
                      <div class="row">
                        <div class="col-md-4">
                          <span class="menu-desc">
                            <a href="#" @click.prevent="openMenu('/')" class="btn-2">01. HOME</a>
                            <a href="#" @click.prevent="openMenu('/products')">02. PRODUCTS</a>
                            <a
                              href="#0"
                              class="js-cd-panel-trigger"
                              data-panel="main"
                            >03. CONTACT US</a>
                            <a href="http://janbros.com/" target="blank">04. THE COMPANY</a>
                          </span>
                        </div>
                        <div class="col-md-8">
                          <h2>The Story</h2>
                          <p>Launched in 2008, Henna Speedy was a welcome relief to many people who had to suffer through the inconvenience of age-old method of coloring the hair which usually took about an hour. With Henna Speedy it was done in 5 minutes. Add to it the Magic of Henna; it was just perfect.
                            <br>
                            <br>In 2013 Henna Speedy revolutionized the world of hair coloring with the introduction of hair coloring shampoo: a very simple method of hair coloring, just like shampooing your hair. No more mixing cups and trays and no more brushes and combs. Just open, pour, and apply.
                            <br>
                            <br>At Henna Speedy, we constantly strive to bring to you a better product and add a bit more pleasure to your life.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <svg class="shape-overlays" viewBox="0 0 100 100" preserveAspectRatio="none">
                  <path class="shape-overlays__path"></path>
                  <path class="shape-overlays__path"></path>
                  <path class="shape-overlays__path"></path>
                </svg>
              </div>
            </main>
          </div>
        </div>
        <div class="shop-wrapper"></div>
      </div>
    </div>
    <div class="cd-panel cd-panel--from-right js-cd-panel-main">
      <div class="cd-panel__container">
        <div class="cd-panel__content">
          <div class="comment-headding">
            <h3>Send your comments</h3>
            <a href="#0" class="cd-panel__close js-cd-close">Close</a>
          </div>
          <div class="contact-form">
            <div class="row">
              <div class="col-md-12">
                <form id="contact-form">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <input placeholder="Name" type="text" required v-model="form.name">
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <input placeholder="Email" type="email" required v-model="form.email">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <input placeholder="Phone" type="tel" required v-model="form.phone">
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <textarea placeholder="Message" required v-model="form.message"></textarea>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <button class="red-btn2" @click="contactUs">Submit</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-12">
                <div class="cnt-bg">
                  <div class="contact-item">
                    <span>
                      <i class="fa fa-map-marker"></i>
                    </span>
                    <div class="info-cont">
                      <p>Near Kuwaiti Mosque</p>
                      <p>Behind Gold Land</p>
                      <p>Gold Souq, Deira</p>
                      <p>Dubai, UAE</p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <span>
                      <i class="fa fa-envelope"></i>
                    </span>
                    <div class="info-cont">
                      <p>
                        <strong>Phone</strong>
                      </p>
                      <p>
                        <a href="mailto:janbros@eim.ae" target="_top">janbros@eim.ae</a>
                      </p>
                    </div>
                  </div>
                  <div class="contact-item">
                    <span>
                      <i class="fa fa-phone"></i>
                    </span>
                    <div class="info-cont">
                      <p>
                        <strong>Phone</strong>
                      </p>
                      <p>
                        <a href="tel:+971 4-225-1188">+971 4-225-1188</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!4v1550071484840!6m8!1m7!1sy6FnWxE0JGJMtKYFrycEwA!2m2!1d25.27247001278623!2d55.3000185636728!3f353.06586!4f0!5f0.7820865974627469"
                    width="600"
                    height="450"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShapeOverlays from "@/assets/js/HamburgerMenu.js";
import { required, minLength, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "HeaderWrapper",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        message: ""
      },
      elmHamburger: null,
      gNavItems: null,
      elmOverlay: null,
      overlay: null
    };
  },
  mounted() {
    //this.initHambergerMenu();
    this.initMenu();

    // Slide In Panel - by CodyHouse.co
    var panelTriggers = document.getElementsByClassName("js-cd-panel-trigger");
    if (panelTriggers.length > 0) {
      for (var i = 0; i < panelTriggers.length; i++) {
        (function(i) {
          var panelClass =
              "js-cd-panel-" + panelTriggers[i].getAttribute("data-panel"),
            panel = document.getElementsByClassName(panelClass)[0];
          // open panel when clicking on trigger btn
          panelTriggers[i].addEventListener("click", function(event) {
            event.preventDefault();
            addClass(panel, "cd-panel--is-visible");
          });
          //close panel when clicking on 'x' or outside the panel
          panel.addEventListener("click", function(event) {
            if (
              hasClass(event.target, "js-cd-close") ||
              hasClass(event.target, panelClass)
            ) {
              event.preventDefault();
              removeClass(panel, "cd-panel--is-visible");
            }
          });
        })(i);
      }
    }

    //class manipulations - needed if classList is not supported
    //https://jaketrent.com/post/addremove-classes-raw-javascript/
    function hasClass(el, className) {
      if (el.classList) return el.classList.contains(className);
      else
        return !!el.className.match(
          new RegExp("(\\s|^)" + className + "(\\s|$)")
        );
    }
    function addClass(el, className) {
      if (el.classList) el.classList.add(className);
      else if (!hasClass(el, className)) el.className += " " + className;
    }
    function removeClass(el, className) {
      if (el.classList) el.classList.remove(className);
      else if (hasClass(el, className)) {
        var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
        el.className = el.className.replace(reg, " ");
      }
    }
  },
  methods: {
    goToHome() {
      this.$router.push({ path: "/" });
    },
    contactUs(e, elt2) {
      let me = this;
      var form = document.getElementById("contact-form");
      var isValidForm = form.checkValidity();
      //console.log("elt1", elt1);
      //console.log("elt2", elt2);
      if (isValidForm) {
        e.preventDefault();
        var settings = {
          async: true,
          crossDomain: true,
          url: me.$root.serverRoute("contactUs"),
          method: "POST",
          dataType: "json",
          data: JSON.stringify(me.form)
        };
        this.$root.loadingQueueSize++;
        $.ajax(settings)
          .done(function(resp) {
            me.$root.loadingQueueSize--;
            //console.log(resp);
            if (resp.success == false) {
              me.$root.msgBox.alertType = "danger";
              me.$root.msgBox.message =
                "An error occurs on the server. <br>" + resp.message;
              $("#main-msg-box").modal();
            } else {
              me.$root.msgBox.alertType = "success";
              me.$root.msgBox.message =
                "Thank you. We received you message.<br> We will get back to you soon";
              $("#main-msg-box").modal();

              /*
              me.form = {
                email: ""
              };*/
            }
          })
          .fail(function(resp) {
            me.$root.loadingQueueSize--;
            me.$root.msgBox.alertType = "danger";
            me.$root.msgBox.message =
              "An error occurs on the server 'very big error'";
            $("#main-msg-box").modal();
          });
      }
    },
    initMenu() {
      let me = this;
      this.elmHamburger = document.querySelector(".hamburger");
      this.gNavItems = document.querySelectorAll(".global-menu__item");
      this.elmOverlay = document.querySelector(".shape-overlays");
      this.overlay = new ShapeOverlays(this.elmOverlay);

      me.elmHamburger.addEventListener("click", () => {
        if (me.overlay.isAnimating) {
          return false;
        }
        me.overlay.toggle();
        if (me.overlay.isOpened === true) {
          me.showMenuBox();
        } else {
          me.hideMenuBox();
        }
      });
    },
    hideMenuBox() {
      let me = this;
      //me.overlay.toggle();
      me.elmHamburger.classList.remove("is-opened-navi");
      for (var i = 0; i < me.gNavItems.length; i++) {
        me.gNavItems[i].classList.remove("is-opened");
      }
    },
    showMenuBox() {
      let me = this;
      //me.overlay.toggle();
      me.elmHamburger.classList.add("is-opened-navi");
      for (var i = 0; i < me.gNavItems.length; i++) {
        me.gNavItems[i].classList.add("is-opened");
      }
    },
    initHambergerMenu() {
      const elmHamburger = document.querySelector(".hamburger");
      const gNavItems = document.querySelectorAll(".global-menu__item");
      const elmOverlay = document.querySelector(".shape-overlays");
      const overlay = new ShapeOverlays(elmOverlay);

      elmHamburger.addEventListener("click", () => {
        if (overlay.isAnimating) {
          return false;
        }
        overlay.toggle();
        if (overlay.isOpened === true) {
          elmHamburger.classList.add("is-opened-navi");
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.add("is-opened");
          }
        } else {
          elmHamburger.classList.remove("is-opened-navi");
          for (var i = 0; i < gNavItems.length; i++) {
            gNavItems[i].classList.remove("is-opened");
          }
        }
      });
    },
    openMenu(menuPath) {
      this.overlay.toggle();
      this.hideMenuBox();
      this.$router.push({ path: menuPath });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
.logo {
  cursor: pointer;
}

a.brand-janbros {
  font-size: 16px !important;
  color: #0176bf !important;
}
</style>
